'use client';

import { useCallback } from 'react';
import { useNotIdle } from '@/hooks/use-not-idle';

const KEEP_ALIVE_EVENTS: (keyof HTMLElementEventMap)[] = ['click', 'keydown', 'scroll', 'touchstart'];

type UseSessionKeepAliveOptions = {
    onActivity: () => void | Promise<void>;
};

export const useSessionKeepAlive = ({ onActivity }: UseSessionKeepAliveOptions) => {
    const handleKeepAlive = useCallback(() => {
        onActivity();
    }, [onActivity]);

    useNotIdle(handleKeepAlive, {
        events: KEEP_ALIVE_EVENTS
    });
};
